import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { NotificationState } from './types';
import { RootState } from '@/store/types';

export const state: NotificationState = {
  message: '',
  mode: '',
  dialogMessage: '',
};

const namespaced = true;

export const notification: Module<NotificationState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
